import React from 'react';
import heroWave from '../../../assets/quick-richuels-waves/wave-hero.jpg';
import ForecastProgressFooter from '../forecast/ForecastProgressFooter';
import {
  ERROR_MESSAGE,
  HERO_EYEBROW,
  LOADING_MESSAGE,
} from './constants';
import { ArrowIcon } from './icons';
import styles from './YourQuickRichuelsPage.module.css';

export function PageShell({ children, busy = false }) {
  return (
    <div
      className={styles.yourQuickRichuelsPage}
      data-page="your-quick-richuels"
      aria-busy={busy}
    >
      {children}
    </div>
  );
}

export function LoadingState() {
  return (
    <div className={styles.loadingState} aria-busy="true" aria-live="polite">
      <span className={styles.loadingSpinner} aria-hidden="true">
        <span className={styles.loadingSpinnerInner} />
      </span>
      <p className={styles.loadingText}>{LOADING_MESSAGE}</p>
    </div>
  );
}

export function ErrorState({ onRetry, onGoHome }) {
  return (
    <section className={styles.errorState} aria-live="polite">
      <p className={styles.errorText}>{ERROR_MESSAGE}</p>
      <div className={styles.errorActions}>
        <button type="button" className={styles.retryBtn} onClick={onRetry}>
          Try again
        </button>
        <button type="button" className={styles.finishBtn} onClick={onGoHome}>
          Go to Home
        </button>
      </div>
    </section>
  );
}

export function MeetExpertBanner({ onMeetExpert }) {
  return (
    <ForecastProgressFooter
      className={styles.meetExpertBanner}
      onStartMove={onMeetExpert}
      ctaLabel="Meet an Expert"
      ariaLabel="Meet an expert"
    />
  );
}

export function PageHeader({ onSeeWhatsNext }) {
  return (
    <header className={styles.heroBanner}>
      <div className={styles.heroCopy}>
        <p className={styles.heroEyebrow}>{HERO_EYEBROW}</p>
        <h1 className={styles.heroTitle}>
          We’re here to guide you through
          <span className={styles.heroTitleBreak} />
          {' '}one clear <span className={styles.heroTitleAccent}>next step</span> at a time.
        </h1>
        <p className={styles.heroSubtitle}>
          Build your financial confidence with quick, practical Richuels.
          {' '}
          <br className={styles.heroSubtitleBreak} />
          Browse every track whenever you are ready.
        </p>
        <button type="button" className={styles.heroCta} onClick={onSeeWhatsNext}>
          See What's Next
          <ArrowIcon className={styles.heroCtaArrow} />
        </button>
      </div>
      <p className={styles.heroQuote}>
        Your Next
        <br />
        Chapter Starts
        <br />
        Now.
      </p>
      <img
        src={heroWave}
        alt=""
        className={styles.heroArt}
        decoding="async"
      />
    </header>
  );
}
